import { ref } from "vue";

/**
 * 画面表示に関わる UI 状態を管理する composable。
 *
 * @returns 画面で利用するリアクティブな状態オブジェクト
 */
export const useShopListUiState = () => {
  const errdialog = ref(false); //エラーダイアログ
  const errMessage = ref(""); //エラーメッセージ
  const editPage = ref(false);
  const confirmPage = ref(false);
  const processFlag = ref(0);
  const confirmDeleteDialog = ref(false);
  const panel = ref<number[]>([0]);
  const overlay = ref(false);

  /**
   * 店舗削除確認ページ 開く
   */
  const openConfirmDeletePage = (): void => {
    //処理フラグ
    processFlag.value = 2;

    //編集ページ表示 OFF
    editPage.value = false;

    //確認ページ表示 ON
    confirmPage.value = true;
  };

  return {
    errdialog,
    errMessage,
    editPage,
    confirmPage,
    processFlag,
    confirmDeleteDialog,
    panel,
    overlay,
    openConfirmDeletePage,
  };
};
